/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {fetch} from '../api'

export const useMutationFetch = createReactQueryMutationHook('fetch', fetch)
